<template>
    <div class="gl-square-btn btn-grey-outline" v-on:click="goBackward">
        Назад
    </div>
</template>

<script>
    export default {
        name: "LiteRightLowerBarBack",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
            adjacentSteps() {
                let stepsOrder = this.$store.state.UI.stepsChain[this.version].stepsOrder
                return stepsOrder[this.activeStep]
            }
        },
        methods: {
            goBackward() {
                this.$router.push({name: this.adjacentSteps.prev}).catch(err=>{})
            }
        }
    }
</script>

<style scoped>

</style>
